import axios from "axios";
import { get_access_token } from "./get_access_token";


export const booking = async (navy, bookingData, user) => {
  console.log("booking user", user);
  const access_token = await get_access_token(user);
  const apiUrl = process.env.REACT_APP_API_URL;

  let data = await axios({
    method: "get",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": access_token,
  },
    url: `${apiUrl}/api/booking`,
    params: {
      navy: navy,
      bookingData: bookingData,
    },
  });

  // let bookingData = {
  //   email: email,
  //   mobile: mobile,
  //   outward_day: searchData.departureDate,
  //   backward_day: searchData.returnDate,
  //   origen: searchData.origen,
  //   destiny: searchData.destiny,
  //   outward_time: selectedSailing.sailingData.outward_time,
  //   backward_time: selectedSailing.sailingData.backward_time,
  //   one_way: searchData.returnDate == null,
  //   acco_code: selectedSailing.acco_code,
  //   tariff_code: selectedSailing.tariff.tariff_code,
  //   acco_code_back: selectedSailing.acco_code,
  //   tariff_code_back: selectedSailing.tariff.tariff_code,
  //   accommodation: selectedSailing.name,
  //   accommodation_back: selectedSailing.name,
  //   amount: selectedSailing.tariff.price,
  //   company: selectedSailing.sailingData.company,
  //   advantage: searchData.advantage,
  //   residence: searchData.residence,
  //   id_familly: idFamily,
  //   id_militar: idMilitar,
  //   passengers: passengers
  // }


  return data.data;
};